import isEmpty from "lodash-es/isEmpty"
import map from "lodash-es/map"

import { chapterBaseAdapter } from "@/3514/adapters"
import type { IChapterBaseDto, IChapterBaseModel } from "@/3514/types"

import type {
    ICoachGroupParticipantModuleByIdDto as IModuleDto,
    ICoachGroupParticipantModuleByIdModel as IModuleModel,
    ICoachGroupParticipantModuleByIdQueryDto as IQueryDto,
    ICoachGroupParticipantModuleByIdQueryModel as IQueryModel
} from "./coach.group-participant.api.types"

export default {
    moduleById(queryDto: IQueryDto): IQueryModel {
        return isEmpty(queryDto)
            ? null
            : {
                  count: queryDto.count,
                  next: queryDto.next,
                  previous: queryDto.previous,
                  results: isEmpty(queryDto.results)
                      ? []
                      : map<IModuleDto, IModuleModel>(
                            queryDto.results,
                            (dto: IModuleDto): IModuleModel => ({
                                chapters: isEmpty(dto.chapters)
                                    ? []
                                    : map<IChapterBaseDto, IChapterBaseModel>(dto.chapters, chapterBaseAdapter),
                                completionDate: dto.completed_at,
                                dueDate: dto.due_date,
                                id: dto.id,
                                longDescription: dto.long_description,
                                name: dto.name,
                                openDate: dto.open_date,
                                order: dto.order,
                                shortDescription: dto.short_description,
                                status: dto.status
                            })
                        )
              }
    }
}
